export default function postMessage(type, payload){
	if(window && window.ReactNativeWebView){
		window.ReactNativeWebView.postMessage(JSON.stringify({
			type: type,
			payload: payload
		}))
	}
}